import React from "react";
import { useTranslation } from 'react-i18next';
import LetoonBeige from "../Components/quarries/LetoonBeige";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function LetoonBeigePage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  // productSeoData.json'da letoonBeige verisi yoksa genel bir SEO oluştur
  const seo = productSeoData[currentLang]?.letoonBeige || {
    title: currentLang === 'tr' ? 'Letoon Beige Mermer - MOCA Mermer' : 'Letoon Beige Marble - MOCA Marble',
    description: currentLang === 'tr' ? 'Letoon Beige mermer ürünü hakkında detaylı bilgi. MOCA Mermer kalitesi ile.' : 'Detailed information about Letoon Beige marble product. With MOCA Marble quality.',
    keywords: currentLang === 'tr' ? 'letoon beige, mermer, doğal taş, moca mermer' : 'letoon beige, marble, natural stone, moca marble'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/letoonbeige"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <LetoonBeige />
    </>
  );
}

export default LetoonBeigePage;
